import { Injectable, ChangeDetectorRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root',
})
export class ModalService{
  bsModalRef: BsModalRef;
  changeDetectorRef: ChangeDetectorRef;
  constructor(private modalService: BsModalService) {}
  openModalWithComponent(modalComponent: any, config: any) {
    this.bsModalRef = this.modalService.show(modalComponent, Object.assign( {backdrop : 'static'}, config));
    return this.bsModalRef;
  }
}
